var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{staticClass:"customNavHeader",style:(_vm.cssVars),attrs:{"toggleable":"lg","type":"dark"}},[_c('b-navbar-nav',[_c('span',[_vm._v(_vm._s(_vm.headerTitle))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }